'use strict'

export let english_endProject={
  Overview: {
    fields: {
      period: {
        title: "Project period",
        help: "Select the actual period for the project. Double click on a date in the calendar to make it the starting date of the project. Single click on a date to make it the end date."
      },
      summary: {
        help: `Review the first approved Project Initiation Document – the baseline when the initiation stage was completed.
          What was the project’s original intent and main goal?
          To what extent did the project deliver on the original intent?
          Did we have any breakthroughs or major failures along the way?`,
        description:"Describe the original main intent of the project and to what extent the project has delivered on the objectives agreed."
      },
      performedAchivements: {
        title: "Delivered by this project",
        help: `What did the original Project Product Description cover? What type of changes happened to the planned products during the lifetime of the project? To what extent did the project experience that products were not delivered, were not delivered on time or did not meet the original requirements? Have the products been handed over to the receiving organization, was the receiving organization prepared and have it accepted the handover?`,
        description: "What was originally agreed to be delivered by the project, what has been delivered and how is it received?"
      },

      benefits: {
        help: `Review the original Business Case. Are we on track to deliver the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case during the project?`,
        description: "Evaluate how the project has met the planned benefits and the business case to date."
      },
      time: {
        help: `What time objectives existed in the original Project Initiation Document and in the original project plan? What was the time ambition in the early days of the project? How has the project delivered compared to those objectives? If deadlines were not met, what were the main reasons and factors?`,
        description: "Describe the project’s original time objectives, and evaluate how the project has performed compared to those objectives"
      },
      cost: {
        help: `Which project cost objectives existed in the original Project Initiation Document and in the original project plan? What was the cost ambition in the early days of the project? How has the project delivered compared to those objectives? If cost limits were broken, what were the main reasons and factors?`,
        description: "Describe the project’s original cost objectives, and evaluate how the project has performed compared to those objectives"
      },

      quality: {
        help: `Which high level quality objectives and requirements existed in the original Project Product Description and the baseline requirement documents? How has the project delivered compared to those requirements? If products were delivered off specification, what were the main reasons and factors?`,
        description: "Describe what the original high level requirements were and to what extent the project has delivered according to those requirements."
      },
      scope: {
        help: `What did the original Project Initiation Document define as the scope? How wide was the project originally? Which disciplines, functions and geographies were included? What type of changes happened to the scope during the lifetime of the project? To what extent did the project deliver on the scope?`,
        description: "Describe which topics or disciplines were originally agreed to be in the project, and to what extent those were covered during the execution of the project."
      },

      risk: {
        help: `How was the risk objective or risk appetite expressed in the original Project Initiation Document? How was risk managed in the project? Were risks managed and reported on thoroughly and responded to appropriately by stakeholders? How did risk exposure impact the end result of the project?`,
        description: "Describe the risk appetite agreed early in the project, how risk was managed and how realized risks impacted the project’s end result?"
      },

      teamPerformance: {
        help: `How was the project team originally organized? Did the team have the skills and capacity needed? Did we have any changes to the team during the project? If so, how did it affect the performance? Any particular good performance in the team to be recognized?`,
        description: "Describe the project team’s performance, in particular, recognition of good performance."
      },
      lessonsDescription: {
        help: `What went well, what went badly and what are the recommendations for future projects of similar nature? What are the key lessons learned? How should these lessons be stored and reused?`,
        description: "Summarize the lessons learned in this project."
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/progress/labels/english_endProject.js